export default __webpack_public_path__ + "static/media/icon-linked.18439b7f.svg";